import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../core';
import { Usuario } from '../usuario';
import { UsuarioSearchAsync } from '../usuario-search';
import { UsuarioFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class UsuarioCrudHttpService implements Crud<Usuario> {
    resource = 'usuario';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os usuários cadastrados */
    search(): Observable<Usuario[]> {
        return this.crudService.search<Usuario>(this.resource);
    }

    searchWithFilter(filter: UsuarioFilter, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<UsuarioSearchAsync> {
        // Params
        let params = new HttpParams()
                            .append('drawDatatable', drawDatatable ? drawDatatable.toString() : null)
                            .append('offset', offset ? offset.toString() : null)
                            .append('limit', limit ? limit.toString() : null)
                            .append('orderBy', orderBy ? orderBy.toString() : null)
                            .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<UsuarioSearchAsync>(this.pathApi, {params});
    }

    /** Procura um único usuário através do seu ID */
    find(id: number): Observable<Usuario> {
        return this.crudService.find<Usuario>(this.resource, id);
    }

    /** Carrega um único usuário através do seu ID */
    load(id: number): Observable<Usuario> {
        return this.crudService.load<Usuario>(this.resource, id);
    }

    /** Insere um novo usuário */
    insert(entity: Usuario): Observable<Usuario> {
        return this.crudService.insert<Usuario>(this.resource, entity);
    }

    /** Altera um usuário existente */
    update(entity: Usuario): Observable<Usuario> {
        entity.senha = undefined; // Garantindo que a senha não é enviada no JSON do PUT
        return this.crudService.update<Usuario>(this.resource, entity);
    }

    /** Exclui um usuário através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
